import { useQuery } from '@tanstack/react-query';

import { getKpiPerformance } from '../api/ach/contracts';
import { useConfig } from './useConfig';

// Fetches per-contract daily KPI performance for the current grid page's ids
// (ADOPS-2705); keyed by the sorted id set. Returns the raw kpi_performance envelope.
function useContractsKpiPerformance(ids: number[]) {
  const { achApiHost } = useConfig();
  const sortedIds = [...ids].sort((a, b) => a - b);

  return useQuery({
    queryKey: ['contractsKpiPerformance', achApiHost, sortedIds],
    // Request the sorted set too so the fetched ids always match the cache key
    // (the response is a map keyed by contract id, so order is irrelevant).
    queryFn: async () => {
      try {
        return await getKpiPerformance(achApiHost, sortedIds);
      } catch (err) {
        // ACH is supplementary — on any failure degrade to no KPI data (the
        // columns simply render empty) rather than erroring or logging out.
        if (import.meta.env.DEV) {
          // eslint-disable-next-line no-console
          console.warn('useContractsKpiPerformance: ACH fetch failed; hiding KPI columns', err);
        }
        return { kpi_performance: {} };
      }
    },
    retry: false,
    enabled: ids.length > 0,
  });
}

export default useContractsKpiPerformance;
